<template>
    <!--
          作者：luoyiming
          时间：2019-10-25
          描述：组件-选择用户
      -->
    <el-dialog title="用户操作数据" :visible.sync="dialogVisible" @close="cancelFunc" 
    :close-on-click-modal="false" :close-on-press-escape="false" width="880px">
   
      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
          <el-table :data="tableData" size="small" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column prop="" label="微信头像" width="70">
              <template slot-scope="scope">
                <img :src="scope.row.user.avatarUrl" class="radius" width="30" height="30" />
              </template>
            </el-table-column>
            <el-table-column prop="user.nickName" label="昵称"></el-table-column>
            <el-table-column prop="user.mobile" label="手机号码"></el-table-column>
            <el-table-column prop="user.gender" label="性别" width="50">
              <template slot-scope="scope">
                <span v-if="Number(scope.row.user.gender) === 1">男</span>
                <span v-else-if="Number(scope.row.user.gender) === 0">女</span>
                <span v-else-if="Number(scope.row.user.gender) === 2">未知</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="类型">
                <template slot-scope="scope">
                <span v-if="scope.row.type == 'article'">文章</span>
                <span v-if="scope.row.type == 'product'">产品</span>
              </template>
            </el-table-column>
            <el-table-column prop="like" label="操作">
                <template slot-scope="scope">
                <span v-if="scope.row.code == 'like'">点赞</span>
                <span v-if="scope.row.code == 'collect'">收藏</span>
                <span v-if="scope.row.code == 'share'">分享</span>
              </template>
            </el-table-column>
          
            
            <el-table-column prop="create_time" label="操作时间" width="140"></el-table-column>
           
          </el-table>
        </div>
  
        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-sizes="[2, 10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
          ></el-pagination>
        </div>
      </div>
  
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmFunc">确 定</el-button>
      </div>
    </el-dialog>
  </template>
  
  <script>
  import DataApi from '@/api/data.js';
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*当前是第几页*/
        curPage: 1,
        /*一页多少条*/
        pageSize: 15,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*搜索表单对象*/
        formInline: {
          /*等级*/
          grade_id: '',
          /*昵称*/
          nickName: '',
          /*手机号码*/
          mobile:'',
          /*性别*/
          sex: ''
        },
        /*会员列表*/
        tableData: [],
        /*性别列表*/
        sex: ['女', '男', '未知'],
        /*选中的*/
        multipleSelection: [],
        /*是否显示*/
        dialogVisible: false,

      };
    },
    props: {
      // 开启弹窗
      open_handle: Boolean,

      code:String,

      type:String,
      // 是否多选
      multi: {
        type: Boolean,
        default: () => {
          return true
        }
      },
     
    },
    created() {
        console.log(this.open_handle);
        this.dialogVisible = this.open_handle;
        this.getTableList();
    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },
  
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
  
      /*获取数据*/
      getTableList() {
        let self = this
        self.loading = true
        let params = self.formInline
        params.page = self.curPage
        params.list_rows = self.pageSize
        params.type = self.type;
        params.code = self.code
        DataApi.getHandleUser(params,true).then(data => {
          self.loading = false
          console.log(data.data.list.data);
          self.tableData = data.data.list.data
          self.totalDataNumber = data.data.list.total
        })
          .catch(error => {
            self.loading = false
          });
      },
  
      /*查询*/
      search() {
        this.curPage = 1;
        this.tableData = [];
        this.getTableList();
      },
  
      /*点击确定*/
      confirmFunc() {
        let params = this.multipleSelection;
        this.emitFunc(params);
      },
  
      /*关闭弹窗*/
      cancelFunc(e) {
        this.emitFunc();
      },
  
      /*发送事件*/
      emitFunc(e) {
        this.dialogVisible = false;
        if (e && typeof e != 'undefined') {
          this.$emit('close', {
            type: 'success',
            params: e
          });
        } else {
          this.$emit('close', {
            type: 'error'
          });
        }
      },
  
      /*监听单选按钮选中事件*/
      selectUser(val) {
        this.multipleSelection = val;
        this.confirmFunc();
      },
  
      /*选择用户*/
      handleSelectionChange(e) {
        this.multipleSelection = e;
      }
    }
  };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/components/handle/handle.vue